<template>
  <div
    class="c-global-footer-nav l-grid__item"
  >
    <h4
      v-if="nav.title"
      class="t-heading-6 u-margin-bottom-small"
    >
      {{ nav.title }}
    </h4>
    <ul
      v-if="nav.navItems.length > 0"
      class="c-global-footer-nav__list u-margin-bottom-small"
    >
      <template v-for="(item, itemIndex) in nav.navItems">
        <li
          v-if="item.linkText"
          :key="itemIndex"
          class="c-global-footer-nav__item t-paragraph"
        >
          <a
            v-if="isRemoteUrl(item.linkUrl) || item.externalLink"
            class="t-link t-link--nav"
            :href="item.linkUrl"
          >{{ item.linkText }}</a>
          <nuxt-link
            v-else
            class="t-link t-link--nav"
            :to="item.linkUrl"
          >
            {{ item.linkText }}
          </nuxt-link>
        </li>
      </template>
    </ul>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    nav: {
      type: Object,
      required: true
    }
  },
  methods:{
    isRemoteUrl(url) {
      const sample = url.substr(0, 4)
      return (sample === "http")
    }
  }
}
</script>

<style lang="scss" scoped>
.c-global-footer-nav {
  @include respond(tab-land) {
    text-align: center;
  }


  &__item {
    @include liReset;
    &:not(:last-child) {
      margin-bottom: rem(10px);
    }
  }
}
</style>
